<template>
  <div class="fill-height full-width">
    <template v-if="!documentLoading && documentHasData">
      <doc-form
        :document-ref="documentRef"
        :document-id="documentId"
        :document="document"
        :document-has-data="documentHasData"
        :form-def-with-behaviours="formDefWithBehaviours"
        :computeds="formDefWithBehaviours.computeds"
        :initial-meta-section-step="metaSectionStep"
        :client-user="clientUser"
      />
    </template>

    <v-card v-else height="100%" class="d-flex align-center justify-center">
      <div class="text-center flex xs12 sm8 md6 lg4 xl2">
        <span v-show="!errorLoadingDocument">
          <v-progress-circular :indeterminate="true" color="primary" /><br>Loading document...
        </span>
        <span v-show="errorLoadingDocument" class="text-left">
          <v-alert type="error" :value="true" outlined class="mx-3">
            Error loading document.
            <span v-show="missingOrInsufficientPermissions">
              <br><br>The document does not exist or you do not have permission to view it.
            </span>
          </v-alert>
        </span>
      </div>
    </v-card>
  </div>
</template>

<script>

import formBehaviours from '@/utils/formBehaviours.js'
import DocForm from '@/components/createFromTemplate/Form.vue'
import stages from '@/stages.js'
import jsonpack from 'jsonpack'
import { getDocumentRef } from '@/dataAccess/documents'
import { getContentData } from '../dataAccess/documents'

export default {
  name: 'FormLoader',
  components: { DocForm },
  props: { documentId: { type: String, default: '' } },
  data: () => ({
    documentLoading: true,
    documentBound: false,
    docExists: false,
    formDefWithBehaviours: {},
    documentHasData: false,
    errorLoadingDocument: false,
    missingOrInsufficientPermissions: true
  }),
  computed: {
    isSingleUser () {
      return this.account.type === 'singleUser'
    },
    hasFormDef () {
      return this.documentBound && 'formDef' in this.document
    },
    docAndDataLoaded () {
      return !this.documentLoading && this.documentData['.key']
    },
    metaSectionStep () {
      if (!this.docAndDataLoaded) { return 0 }
      // TODO ALPHA fix once 'Admin' fixed
      const docType = this.document.accountType === 'admin' ? 'individual' : this.document.accountType
      const docStageLcase = (this.document.stage === 'Admin' ? this.document.accountType : this.document.stage).toLowerCase()
      const docStagesLcase = stages.docTypeStages[docType].map(item => Array.isArray(item) && item.map(item => item.toLowerCase()) || item.toLowerCase())
      return (docStagesLcase.findIndex(stageOrStages =>
        stageOrStages === docStageLcase || stageOrStages.includes(docStageLcase)) +
         1) || 0
    },
    clientUser () {
      if (this.document.client) {
        return this.$gnp(this.$store.getters.usersById, this.document.client)
      }
    }
  },
  watch: {
    hasFormDef: async function (newVal, oldVal) {
      if (!this.documentLoading) { return }
      var document = this.document
      var formDefUnpacked = jsonpack.unpack(document.formDef)
      this.formDefWithBehaviours = formBehaviours(formDefUnpacked)

      this.documentLoading = false

      await this.$loadUser(this.document.client)
    },
    docAndDataLoaded: function (newVal) {
      if (newVal) {
        Object.entries(this.documentData).forEach(([fieldName, value]) => {
          if (fieldName !== '.key') {
            const field = this.formDefWithBehaviours.fieldsByName[fieldName]
            if (field) {
              this.formDefWithBehaviours.form.model[field.nameId].value = value
            }
          }
        })
        this.documentHasData = true
      }
    }
  },
  beforeCreate () {
    this.$store.dispatch('get_appUser')
    this.mapStates(['account'])
  },
  created () {
    this.rebindDocument()
  },
  methods: {
    rebindDocument: async function () {
      /* TODO remove titleBarContents  */
      this.$store.commit('set_titleBarContents', {})
      this.documentBound = false
      this.errorLoadingDocument = false
      this.missingOrInsufficientPermissions = false

      const documentId = this.documentId||this.$options.propsData.documentId
      this.documentRef = getDocumentRef(documentId)

      // TODO BETA use Vuex state instead i.e. remove Vue Firestore dependency
      try {
        await Promise.all([
          this.$binding('document', this.documentRef),
          this.$binding('documentData', getContentData(documentId))
        ])
      } catch (e) {
        this.errorLoadingDocument = true
        if (e.message.includes('permission denied')) {
          this.missingOrInsufficientPermissions = true
        } else {
          // TODO add sentry log
        }
      }
      this.documentBound = true
    }
  }
}

</script>
